import globalCourseCalendarStore from '../../../../../../stores/global-course-calendar';

export // Handle date navigation
const onNavigate = (direction, view2, date: Date) => {
  const newDate = new Date(date);
  const view = globalCourseCalendarStore.displayView;

  switch (direction) {
    case 'PREV':
      switch (view) {
        case 'day':
          newDate.setDate(newDate.getDate() - 1); // Navigate to previous day
          break;
        case 'week':
          newDate.setDate(newDate.getDate() - 7); // Navigate to previous week
          break;
        case 'month':
          newDate.setMonth(newDate.getMonth() - 1); // Navigate to previous month
          break;
        default:
          break;
      }
      break;

    case 'NEXT':
      switch (view) {
        case 'day':
          newDate.setDate(newDate.getDate() + 1); // Navigate to next day
          break;
        case 'week':
          newDate.setDate(newDate.getDate() + 7); // Navigate to next week
          break;
        case 'month':
          newDate.setMonth(newDate.getMonth() + 1); // Navigate to next month
          break;
        default:
          break;
      }
      break;

    default:
      newDate.setDate(new Date().getDate()); // Navigate to today
      break;
  }

  globalCourseCalendarStore.date = newDate;
};
